import React from "react";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";

interface Message {
    id: string;
    text: string;
    sender: string;
    timestamp: string;
}

interface Chat {
    id: string;
    name: string;
    messages: Message[];
}

interface RightPanelProps {
    chat: Chat | null;
    isMobile?: boolean;
    onBack?: () => void;
}

const RightPanel: React.FC<RightPanelProps> = ({ chat, isMobile, onBack }) => {
    return (
        <div className={`${isMobile ? "w-full" : "w-1/4"} bg-gray-50 p-4`}>
            {isMobile && (
                <button className="flex items-center gap-1 mb-3 cursor-pointer" onClick={onBack}>
                    <ArrowLeftIcon className="w-5 h-5" />
                    <span className="font-medium">Back</span>
                </button>
            )}
            {chat ? (
                <>
                    <h2 className="text-lg font-bold">Basic Info</h2>
                    <h2 className="text-lg font-bold">{chat.name}</h2>
                    <p>Village : Jam bhambhaliya</p>
                    <p>Taluka : Kalawad</p>
                    <p>District : Rajkot</p>
                    <p>State : Gujarat</p>
                    <p>Country : India</p>
                    <p>Approved By : Nimesh Trivedi</p>
                    <p>Approved At : 01-01-2025 12:23</p>
                </>
            ) : (
                <p>No chat selected.</p>
            )}
        </div>
    );
};

export default RightPanel;
